import Collapse from './Collapse';

export { default as useCollapse } from './useCollapse';
export default Collapse;
